import { setLoading } from "redux/actions/app.actions";
import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import { getServerErrorString } from "utils/common";

export const sendBroadcastNotification = (values, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request("Notifications/Broadcast", "post", values, true)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Notification sent successfully"
        );
        callback?.();
        return { status: "success", data: res?.data };
      })
      .catch((e) => {
        openNotificationWithIcon("error", "Error!", getServerErrorString(e));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
